import IntroduceMobile from "../../../../src/events/2022/12/introduce-mobile/main";
import * as React from 'react';
export default {
  IntroduceMobile,
  React
};